var React = require('react');

function IconTrash (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("g",null,[React.createElement("path",{"d":"M42.943,6H33.5V3c0-1.654-1.346-3-3-3h-8c-1.654,0-3,1.346-3,3v3h-9.443C8.096,6,6.5,7.596,6.5,9.557V14h2h36h2V9.557   C46.5,7.596,44.904,6,42.943,6z M31.5,6h-10V3c0-0.552,0.449-1,1-1h8c0.551,0,1,0.448,1,1V6z","data-original":"#000000","className":"active-path","data-old_color":"#000000","fill":"#A2A2A2","key":0}),React.createElement("path",{"d":"M8.5,49.271C8.5,51.327,10.173,53,12.229,53h28.541c2.057,0,3.729-1.673,3.729-3.729V16h-36V49.271z","data-original":"#000000","className":"active-path","data-old_color":"#000000","fill":"#A2A2A2","key":1})])));
}

IconTrash.defaultProps = {"version":"1.1","id":"Capa_1","x":"0px","y":"0px","viewBox":"0 0 53 53","style":{"enableBackground":"new 0 0 53 53"},"xmlSpace":"preserve","width":"512px","height":"512px"};

module.exports = IconTrash;

IconTrash.default = IconTrash;
